import { Typography, Box } from "@mui/material";
import StoreButton from "../StoreButton";

const AppCard = ({
  variant = "default",
  title,
  description,
  features
}) => {
  const isEntregador = variant === "entregador";

  const cardStyle = {
    position: "relative",
    borderRadius: "1.5rem",
    padding: "2rem",
    transition: "all 0.3s ease",
    border: isEntregador
      ? "1px solid var(--background-color2)"
      : "1px solid #EEB547",
    backgroundColor: isEntregador
      ? "var(--background-color1)"
      : "var(--background-color1)",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: isEntregador
        ? "0 4px 12px rgba(0,0,0,0.1)"
        : "0 4px 12px rgba(238, 181, 71, 0.2)",
    }
  };

  return (
    <Box sx={cardStyle}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          color: isEntregador ? "var(--text-color0)" : "#EEB547",
          marginBottom: "0.5rem",
          textAlign: "center",
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: "var(--text-color2)",
          textAlign: "center",
          marginBottom: "1.5rem",
          lineHeight: 1.6,
          minHeight: "2.5rem",
        }}
      >
        {description}
      </Typography>

      <Box sx={{ marginBottom: "1.5rem" }}>
        {features.map((feature, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              marginBottom: "0.75rem",
              fontSize: "0.95rem",
              color: "var(--text-color2)",
            }}
          >
            <Box
              sx={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                backgroundColor: isEntregador
                  ? "var(--text-color1)"
                  : "#EEB547",
                flexShrink: 0,
              }}
            />
            {feature}
          </Box>
        ))}
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
        <StoreButton
          store="google"
          variant={variant}
          href={
            isEntregador
              ? "https://play.google.com/store/apps/details?id=br.com.igoobapp.delivery"
              : "https://play.google.com/store/apps/details?id=br.com.igoobapp"
          }
        />
        <StoreButton
          store="apple"
          variant={variant}
          href={
            isEntregador
              ? "https://apps.apple.com/br/app/igoob-entregador/id6767210955"
              : "https://apps.apple.com/br/app/igoob-app/id6767186506"
          }
        />
      </Box>
    </Box>
  );
};

export default AppCard;
